export interface GameEvent {
  readonly type: string;
}

type EventHandler<T extends GameEvent> = (event: T) => void;

/**
 * Sistemler arası gevşek bağlı iletişim kanalı.
 */
export class EventBus {
  private readonly handlers = new Map<string, Set<EventHandler<GameEvent>>>();

  subscribe<T extends GameEvent>(eventType: T['type'], handler: EventHandler<T>): () => void {
    const set = this.handlers.get(eventType) ?? new Set();
    set.add(handler as EventHandler<GameEvent>);
    this.handlers.set(eventType, set);

    return () => {
      set.delete(handler as EventHandler<GameEvent>);
    };
  }

  publish<T extends GameEvent>(event: T): void {
    const set = this.handlers.get(event.type);
    if (!set) {
      return;
    }

    for (const handler of set) {
      handler(event);
    }
  }

  clear(): void {
    this.handlers.clear();
  }
}

/** Olay tipleri — Phase 2+ genişletilecek */
export const GameEvents = {
  appReady: 'app:ready',
  runStarted: 'run:started',
  runEnded: 'run:ended',
} as const;
